<template>
    <ul>
        <li v-for="(activity, activityIndex) in reversedParcelActivity(parcel.activities)" :key="activityIndex" :class="{ 'active-yellow': activityIndex === parcel.activities.length - 1 }">
            <span class="date-time">{{ moment(activity.datetime).format('YYYY MM DD, HH:mm') }}</span>
            <span class="track-info">
                <strong>{{ activity.status }}</strong>
                {{ activity.city }}
                {{ activity.zip_code }}
                {{ activity.country }}
            </span>
        </li>
    </ul>
</template>
<script>
export default {
    props: {
        parcel: {
            type: Object,
            require: true,
        },
    },
    methods: {
        reversedParcelActivity: function(parcelActivity){
            return structuredClone(parcelActivity).reverse();
        }
    }
}
</script>
